import moment, { Duration, Moment } from 'moment';
import { subMonths, startOfMonth, getDate, addDays } from 'date-fns';

export const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const TIME_FORMAT = 'HH:mm';
export const TIME_SECONDS_FORMAT = `HH:mm:ss`;
export const TIME_MILLISECONDS_FORMAT = `HH:mm:ss.SSS`;
export const ALASKA_TIME_ZONE = 'US/Alaska';

export interface DateRange {
  startDate: Moment;
  endDate: Moment;
}

export const millisecondsToHours = (time: number | Duration, format?: boolean): string => {
  const day = moment.duration(time).days();
  const hour = moment.duration(time).hours();
  const minutes = moment.duration(time).minutes();
  const hours = day * 24 + hour;

  if (format) {
    return `${hours}h ${minutes}m`;
  } else {
    const hourStr = hours.toString().length < 2 ? `0${hours}` : hours.toString();
    const minutesString = minutes.toString().length < 2 ? `0${minutes}` : minutes.toString();
    return `${hourStr}:${minutesString}`;
  }
};

export const simplifyTime = (time: string) => {
  const formatTime = time.split(':');
  return `${formatTime[0]}:${formatTime[1]}`;
};

export const formatStartTime = (time: string): string => {
  const timeZone = time.split(' ')[1];
  return `${simplifyTime(time)} ${timeZone}`;
};

export const getDateMoment = (
  date: string,
  duration?: moment.DurationInputArg1,
  unit?: moment.DurationInputArg2,
): Moment => {
  return moment(date, `YYYY-MM-DD ${TIME_MILLISECONDS_FORMAT}Z`).add(duration, unit);
};

export const getDateWithoutTimezone = (logDate: string): Date => {
  const utcOffset = new Date().getTimezoneOffset() / 60;
  const splitDate = logDate.split('-');
  const [year, month, date] = splitDate;
  return new Date(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(date), utcOffset));
};

export const isEndTimeNextDay = (date: Date): boolean => {
  return date.getHours() === 0 && date.getHours() === 0;
};

export const getDate6MonthsBack = () => {
  const date = new Date();
  const pastMonth = startOfMonth(subMonths(date, 6));
  const currentDate = getDate(date);

  return addDays(pastMonth, currentDate - 1);
};

export const formatTimeAsMoment = (time: string) => {
  return moment({ h: Number(time.split(':')[0]), m: Number(time.split(':')[1]) });
};
